const updates = [
  { date: '2026-07-31', title: '《暗夜追踪》第三季全集上线，高清完整版一口气追完', tag: '新剧上线' },
  { date: '2026-07-30', title: '暑期档特别企划：百部经典电影免费重温活动开启', tag: '活动' },
  { date: '2026-07-29', title: '《星际迷航：新纪元》4K修复版独家上线', tag: '高清修复' },
  { date: '2026-07-28', title: '平台新增"智能跳过片头"功能，追剧体验再升级', tag: '功能更新' },
  { date: '2026-07-27', title: '七月热度榜：《流光之城》蝉联三周冠军', tag: '排行' },
  { date: '2026-07-26', title: '《山河纪行》纪录片系列第五季回归，探索自然之美', tag: '纪录片' },
  { date: '2026-07-25', title: '动画专区新增30部高分番剧，二次元爱好者有福了', tag: '片库扩充' },
  { date: '2026-07-24', title: '平台服务器全面升级，全网流畅播放体验再创新高', tag: '系统升级' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full border border-primary-500/20 mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            平台动态 · 实时更新
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            关注黄瓜影院每日更新，不错过任何精彩内容
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-200/60"></div>
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-12 pb-6 md:pb-8 last:pb-0">
                <div className="absolute left-2.5 md:left-3.5 top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="bg-background-50 rounded-lg border border-background-200/60 p-4 md:p-5">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2">
                    <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-accent-500/10 text-accent-400 rounded-md w-fit whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200 cursor-pointer no-underline"
          >
            查看更多动态 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}